export const enum ModalResult {
    KEEP_OPEN = "KEEP_OPEN",
    CLOSE = "CLOSE",
}
